"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EnergyClass = _ref => {
  let {
    prefix,
    children,
    className
  } = _ref;
  if (!children) return null;
  return _react.default.createElement("span", {
    className: `${prefix}price-module__energy-class`
  }, children);
};
EnergyClass.defaultProps = {
  prefix: ''
};
var _default = EnergyClass;
exports.default = _default;